import { useContext, useEffect, useState } from "react";
import {
  Modal,
  Form,
  Input,
  Select,
  DatePicker,
  Button,
  TimePicker,
} from "antd";
import SearchProvider from "../../Provider/SearchProvider";
import ClinicProvider from "../../Provider/ClinicProvider";
import { useNavigate } from "react-router-dom";
const Appointment = () => {
  const navigate = useNavigate();
  const {
    addAppointmentPopup,
    setAddAppointmentPopup,
    addAppointmentFormLoader,
    setAddAppointmentFormLoader,
    addNewAppointment,
    addAppointmentForm,
  } = useContext(SearchProvider);
  const { clinicData } = useContext(ClinicProvider);
  const [doctorList, setDoctorList] = useState([]);
  const [selectedDoctor, setSelectedDoctor] = useState(null);
  // const [selectedDate, setSelectedDate] = useState(null);
  const [captcha, setCaptcha] = useState("");
  const [captchaAnswer, setCaptchaAnswer] = useState("");
  const phone = [
    { value: "+94", label: "+94" }, // srilanka
    { value: "+91", label: "+91" }, // India
    { value: "+1", label: "+1" }, // USA
    { value: "+44", label: "+44" }, // UK
    { value: "+49", label: "+49" }, // Germany
    // Add more countries as needed
  ];
  console.log("clinicData", clinicData?.[0]?._id);
  const { RangePicker } = DatePicker;
  useEffect(() => {
    generateCaptcha();
    if (clinicData?.[0]?.doctor_list?.length) {
      const options = clinicData[0].doctor_list.map((doctor) => ({
        label: `Dr. ${doctor?.doctor_details?.name}`,
        value: doctor?.doctor_details?._id,
      }));
      setDoctorList(options);
      if (!selectedDoctor && options.length) {
        setSelectedDoctor(options[0]?.value); // Set the first doctor as default (optional)
      }
    }
  }, [clinicData]);
  const generateCaptcha = () => {
    // Simple math problem
    const num1 = Math.floor(Math.random() * 10) + 1;
    const num2 = Math.floor(Math.random() * 10) + 1;
    setCaptcha(`${num1} + ${num2}`);
    setCaptchaAnswer(num1 + num2);
  };
  const handleFinish = (formValues) => {
    if (parseInt(formValues.captcha) !== captchaAnswer) {
      addAppointmentForm.setFields([
        {
          name: "captcha",
          errors: ["Captcha is incorrect!"],
        },
      ]);
      return;
    }
    // console.log("formValues", formValues);
    const name = `${formValues.first_name} ${formValues.last_name}`;
    const selectedDateTime = formValues.date;
    const selectedTime = formValues.time;
    // console.log("Selected Date and Time:", selectedDateTime);
    const clinicId = clinicData?.[0]?._id;
    if (selectedDateTime) {
      const date = selectedDateTime.format("YYYY-MM-DD");
      const time = selectedTime.format("hh:mma").toUpperCase();
      const dataToSend = {
        name: name, // Merged name
        email: formValues.email,
        phone: formValues.phone,
        country_code: formValues.country_code,
        date: date, // 'YYYY-MM-DD'
        time: time, // 'hh:mma'
        clinic_id: clinicId,
        doctor_id: formValues.doctor_id, // Assuming the doctor_id is available in form values
      };
      addNewAppointment(dataToSend, navigate,);
      // console.log("dataToSend", dataToSend);
    }
  };
  const handleSelectChange = (value) => {
    setSelectedDoctor(value); // Update selected doctor in state
  };
  const handleCustomOk = () => {
    // Handle the custom OK button action (you can close the modal or do other actions)
    console.log("Custom OK clicked");
  };
  return (
    <Modal
      open={addAppointmentPopup}
      // open={true}
      footer={null}
      onCancel={() => setAddAppointmentPopup(false)}
    >
      <h1 className="font-primary font-bold text-[1.5rem] bg-primary px-[20px] py-[4vh] text-white">
        Book an Appointment
      </h1>
      <div className="p-[20px]">
        <h3 className="font-primary text-primary font-bold text-[1.6rem] text-center mb-[10px]">
          {clinicData?.[0]?.name}
        </h3>
        <Form
          className="flex flex-wrap gap-4 justify-between"
          form={addAppointmentForm}
          onFinish={(values) => handleFinish(values)}
        >
          <Form.Item
            className="w-full md:w-[calc(50%-10px)] mb-[1rem]"
            name="first_name"
            rules={[
              {
                required: true,
                message: "Please input your first name!",
              },
            ]}
          >
            <Input size="large" placeholder="First Name" className="w-full" />
          </Form.Item>
          <Form.Item
            className="w-full  md:w-[calc(50%-10px)]  mb-[1rem]"
            name="last_name"
            rules={[
              {
                required: true,
                message: "Please input your last name!",
              },
            ]}
          >
            <Input size="large" placeholder="Last Name" className="w-full" />
          </Form.Item>
          <Form.Item
            className="w-full  md:w-[calc(50%-10px)]  mb-[1rem]"
            name="email"
            rules={[
              {
                required: true,
                message: "Please input your email!",
              },
            ]}
          >
            <Input size="large" placeholder="Email" className="w-full" />
          </Form.Item>
          <Form.Item
            className="w-full  md:w-[calc(50%-10px)]  mb-[1rem]"
            name="doctor_id"
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Select
              placeholder="Select Doctor"
              size="large"
              options={doctorList}
              value={selectedDoctor} // Bind selected doctor to the field
              onChange={handleSelectChange} // Update selected doctor on change
            />
          </Form.Item>
          <Form.Item
            className="w-[30%] mb-[1rem]"
            name="country_code"
            initialValue="+94"
            rules={[
              { required: true, message: "Please select a country code!" },
            ]}
          >
            <Select size="large" options={phone} />
          </Form.Item>

          <Form.Item
            className="w-[calc(70%-20px)] mb-[1rem]"
            name="phone"
            rules={[{ required: true }]}
          >
            <Input size="large" placeholder="Phone Number" className="w-full" />
          </Form.Item>

          <Form.Item
            style={{ width: "48%", marginBottom: "1rem" }}
            name="date"
            rules={[
              {
                required: true,
                message: "Please select a date!",
              },
            ]}
          >
            <DatePicker
              placeholder="Select Date"
              size="large"
              className="w-full"
              disabledDate={(current) =>
                current && current < new Date().setHours(0, 0, 0, 0)
              }
            />
          </Form.Item>
          <Form.Item
            style={{ width: "48%", marginBottom: "1rem" }}
            name="time"
            rules={[
              {
                required: true,
                message: "Please select a date!",
              },
            ]}
          >
            <TimePicker
              format="HH:mm"
              size="large"
              placeholder="Select Time"
              className="w-full"
              minuteStep={10}
            />
          </Form.Item>
          <h3 className="font-primary text-black font-normal text-[1.6rem]">
            Solve: {captcha}
          </h3>
          <Form.Item
            className="w-full md:w-[calc(100%)] mb-[1rem]"
            name="captcha"
            rules={[
              {
                required: true,
                message: "Please solve the captcha!",
              },
            ]}
          >
            <Input
              size="large"
              placeholder={`enter captcha`}
              className="w-full"
            />
          </Form.Item>
          <Button
            type="primary"
            size="large"
            htmlType="submit"
            className="w-full bg-primary text-white"
            loading={addAppointmentFormLoader}
          >
            Book Appointment
          </Button>
        </Form>{" "}
      </div>
    </Modal>
  );
};

export default Appointment;
